import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridState } from '../../../../model/settings.model';

@Component({
  selector: 'custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomFilterComponent {
  @Input() filterModel: string;
  @Input() filters: GridState[] = [];
  @Output() filterChange = new EventEmitter<string>();
  @Output() addFilter = new EventEmitter();
  @Output() deleteFilter = new EventEmitter();
  @Output() updateFilter = new EventEmitter();
  @Output() restoreFilter = new EventEmitter();
}
